import React from 'react';
import { numericFormatter } from 'react-number-format';

import { Paper, Grid, Typography } from '@material-ui/core';
import Loader from 'components/Loader';

export default function Resume({ resume, isMobile, isLoading }) {
  if(isMobile) {
    return(
      <Grid container spacing={1} style={{ marginBottom: 10 }}>
        <Grid item xs={12}>
          <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: '10px solid #13BC4B', padding: 8 }}>
            <Loader isLoading={isLoading}>
              <Typography variant="subtitle1" color="primary">
                Total de faturamento
              </Typography>
              <Typography variant="h6" color="primary">
                R$ {numericFormatter(resume?.totalAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Loader>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: '10px solid #13BC4B', padding: 8 }}>
            <Loader isLoading={isLoading}>
              <Typography variant="subtitle1" color="primary">
                Pedidos pagos
              </Typography>
              <Typography variant="h6" color="primary">
                {resume?.countPaid}
              </Typography>
            </Loader>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: '10px solid #757575', padding: 8 }}>
            <Loader isLoading={isLoading}>
              <Typography variant="subtitle1" color="primary">
                Total de pedidos
              </Typography>
              <Typography variant="h6" color="primary">
                {resume?.count}
              </Typography>
            </Loader>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: '10px solid #757575', padding: 8 }}>
            <Loader isLoading={isLoading}>
              <Typography variant="subtitle1" color="primary">
              Ticket médio
              </Typography>
              <Typography variant="h6" color="primary">
                R$ {numericFormatter(resume?.mediumAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Loader>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  return(
    <Grid container spacing={2} style={{ marginBottom: 10 }}>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper style={{ borderBottom: '5px solid #13BC4B', padding: '10px 0 10px 0' }}>
          <Loader isLoading={isLoading}>
            <Typography variant="subtitle1" color="primary" align="center">
              Total de faturamento
            </Typography>
            <Typography variant="h4" color="primary" align="center">
              R$ {numericFormatter(resume?.totalAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
            </Typography>
          </Loader>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper style={{ borderBottom: '5px solid #13BC4B', padding: '10px 0 10px 0' }}>
          <Loader isLoading={isLoading}>
            <Typography variant="subtitle1" color="primary" align="center">
              Pedidos pagos
            </Typography>
            <Typography variant="h4" color="primary" align="center">
              {resume?.countPaid}
            </Typography>
          </Loader>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper style={{ borderBottom: '5px solid #13BC4B', padding: '10px 0 10px 0' }}>
          <Loader isLoading={isLoading}>
            <Typography variant="subtitle1" color="primary" align="center">
              Total de pedidos
            </Typography>
            <Typography variant="h4" color="primary" align="center">
              {resume?.count}
            </Typography>
          </Loader>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper style={{ borderBottom: '5px solid #757575', padding: '10px 0 10px 0' }}>
          <Loader isLoading={isLoading}>
            <Typography variant="subtitle1" color="primary" align="center">
              Ticket médio
            </Typography>
            <Typography variant="h4" color="primary" align="center">
              R$ {numericFormatter(resume?.mediumAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
            </Typography>
          </Loader>
        </Paper>
      </Grid>
    </Grid>
  );
}